import { useState, useEffect} from 'react';
import { useGLTF } from '@react-three/drei';

export default function Model({ modelPath, position, scale, rotation, onLoadComplete, isMain, onClick }) {
  const { scene, loading } = useGLTF(modelPath);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (!loading) {
      onLoadComplete();
    }
  }, [loading, onLoadComplete]);

  const handlePointerOver = () => {
    if (!isMain) setHovered(true);
  };

  const handlePointerOut = () => {
    if (!isMain) setHovered(false);
  };

  const adjustedScale = hovered ? scale.map((s) => s * 1.055) : scale;

  return (
    <mesh position={position} scale={adjustedScale} rotation={rotation} onClick={onClick} onPointerOver={handlePointerOver} onPointerOut={handlePointerOut}>
      <primitive object={scene} />
    </mesh>
  );
}